export default {
  title: "Priest",
  content: [
    "Fear Ward is now available to all races. Cooldown increased to 3 minutes, last 3 minutes. Fear Ward is now a discipline spell.",
    "Chastise (Dwarf): new spell: Deals Holy damage and immoblizes the target, causing low theat. 20 yd range, 30 sec cooldown.",
    "Feedback (Human) reduced mana cost and increased effect.",
    "Elune’s Grace (Night Elf) now reduces the chance you are hit by melee or ranged attacks by 25% for 15 sec.",
    "Starshards (Night Elf) now deals increased damage and lasts 4 sec. 1 min cooldown.",
    "Damage absorbed by Power Word: Shield now scales with spell healing.",
    "Shadowguard (Troll) orbs now look like shadow orbs instead of lightning.",
    "Reduced the mana cost of Smite and Holy Fire.",
  ],
};
